export const VACANCY_RANGE_OPTIONS = [
    {
        id: 1,
        name: "Link para 300 o menos"
    },
    {
        id: 2,
        name: "Link para más de 300 (Seminario)"
    }
];
export const CUSTOM_SELECT_PADDING = "5px 10px"